export default __webpack_public_path__ + "static/media/Logo-Anvisa.756cb0d4.webp";